import React from "react";
import { Dependency, DefaultDependencySettings } from "index";
import DependencyBase from "./../DependecyBase";

declare global {
    interface Window {
        cookieTractor?: any;
    }

    interface EventTarget {
        cookieTractor?: any;
    }
}

export interface CookieTractorSettings extends DefaultDependencySettings {
    id: string;
    locale: string;
    consentModeEnabled: boolean;
    helmetComponent: React.ComponentType; // This is the wrong type, this needs to be fixed (wrong in everywhere in package).
}

class CookieTractor extends DependencyBase<CookieTractorSettings> {
    static instance: CookieTractor | undefined = undefined;

    // This feels like a bit of a hack...
    static _componentDependencies: Dependency[] = [];
    public static dependency = () => this._componentDependencies.every((dependency) => dependency());

    constructor(prop: CookieTractorSettings) {
        super(prop);
        CookieTractor._componentDependencies.push(this.dependency);
        CookieTractor.instance = this;
    }

    public dependency = () => {
        try {
            const consent = window?.cookieTractor?.userConsent?.consents ?? [];
            return consent.length > 0;
        } catch (err) {
            return false;
        }
    };

    public static onScriptLoaded = () => {
        // We can't do anything here, since CookieTractor injects the consent settings directly into the dataLayer.
        // Events can be added. Check documentation: https://www.cookietractor.se/installationsanvisningar
    };

    render = () => {
        const { id, locale = "sv-SE", helmetComponent: Helmet } = this.props as CookieTractorSettings;

        return (
            <Helmet>
                <script>
                    {`
                    (function() {
                        const elements = document.getElementsByTagName('script')[0];
                        const script = document.createElement('script');
                        script.onload = function () { return window.grebban.gtm.scriptCallback('CookieTractor'); }
                        script.src = 'https://cdn.cookietractor.com/cookietractor.js';
                        script.type = 'text/javascript';
                        script.id = 'CookieTractor'
                        script.setAttribute('data-id', '${id}')
                        script.setAttribute('data-lang', '${locale}')
                        elements.parentNode.insertBefore(script, elements);
                    })();
                `}
                </script>
            </Helmet>
        );
    };
}

export default CookieTractor;
